import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

const devTools = (name = 'Untitled') => {
  if (
    process.env.NODE_ENV === 'development' &&
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__
  ) {
    // eslint-disable-next-line no-underscore-dangle
    return window.__REDUX_DEVTOOLS_EXTENSION__({ name, id: name });
  }
  return f => f;
};

export const configureStore = (
  initialState,
  reducers,
  options = { combine: true },
) =>
  createStore(
    options.combine ? combineReducers(reducers) : reducers,
    initialState,
    compose(applyMiddleware(thunkMiddleware), devTools(options.name)),
  );
